import {Record, type RecordOf} from 'immutable';
import {
  NETWORK_STATUSES,
  type NetworkStatus,
  type CMSStates,
} from './constants';

type CommerceRecordProps = {
  createdOn: string | null | undefined;
  site: string | null | undefined;
  displayName: string | null | undefined;
};

type CommerceAuthRecordProps = {
  isReady: boolean;
  hasConnectedStripe: boolean;
  hasConnectedPaypal: boolean;
  createdOn: string | null | undefined;
  site: string | null | undefined;
  publishableKey: string | null | undefined;
  shortName: string | null | undefined;
  displayName: string | null | undefined;
};

// @ts-expect-error - TS2322 - Type 'Factory<{ createdOn: null; site: null; displayName: null; }>' is not assignable to type 'Factory<CommerceRecordProps>'.
export const CommerceRecord: Record.Factory<CommerceRecordProps> = Record(
  {
    createdOn: null,
    site: null,
    displayName: null,
  },
  'CommerceRecord'
);

// @ts-expect-error - TS2322 - Type 'Factory<{ isReady: false; hasConnectedStripe: false; hasConnectedPaypal: false; createdOn: null; site: null; publishableKey: null; shortName: null; displayName: null; }>' is not assignable to type 'Factory<CommerceAuthRecordProps>'.
export const CommerceAuthRecord: Record.Factory<CommerceAuthRecordProps> =
  Record(
    {
      isReady: false,
      hasConnectedStripe: false,
      hasConnectedPaypal: false,
      createdOn: null,
      site: null,
      publishableKey: null,
      shortName: null,
      displayName: null,
    },
    'CommerceAuthRecord'
  );

export type CommerceRecordType = RecordOf<CommerceRecordProps>;
export type CommerceAuthRecordType = RecordOf<CommerceAuthRecordProps>;

type CommerceStatusRecordProps = {
  requestStatus: NetworkStatus;
  cmsState: CMSStates | null | undefined;
  commerce: CommerceRecordType;
  commerceAuth: CommerceAuthRecordType;
};

// @ts-expect-error - TS2322 - Type 'Factory<{ requestStatus: "INIT"; cmsState: null; commerce: Record<CommerceRecordProps> & Readonly<CommerceRecordProps>; commerceAuth: Record<...> & Readonly<...>; }>' is not assignable to type 'Factory<CommerceStatusRecordProps>'.
export const CommerceStatusRecord: Record.Factory<CommerceStatusRecordProps> =
  Record(
    {
      requestStatus: NETWORK_STATUSES.INIT,
      cmsState: null,
      commerce: CommerceRecord(),
      commerceAuth: CommerceAuthRecord(),
    },
    'CommerceStatusRecord'
  );

export type CommerceStatusRecordType = RecordOf<CommerceStatusRecordProps>;
